<template>
  <div>
    <v-card class="crud-dialog">
      <v-card-title class="headline">
        <v-icon>security</v-icon> Firmador Grupal
        <v-btn icon @click.native="cerrar_ventana">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs4 v-show="detalles">
            <div class="demofi-container">
              <demofi
                :solicitud="$store.state.selected"
                :on-success="cambiarEstado"></demofi>

            </div>
          </v-flex>
          <v-flex xs8 :class="{ xs12: !detalles }">
            <v-card-actions class="margin-0 p-l-0 p-r-0 p-t-0">
              <v-spacer></v-spacer>
              <v-btn
                color="success"
                @click="firm($store.state.selected)"
                :disabled="$store.state.loading"
                v-if="$store.state.permissions['firmas:create']">
                <v-icon>check</v-icon> {{$t('common.approve') }}
              </v-btn>
            </v-card-actions>
            <div>
              <template v-for="item in $store.state.selected">
                <v-chip v-if="item.id_archivo === 1" color="red" text-color="white">
                  Nro. {{item.id}} - NO TIENE ARCHIVO ADJUNTO
                </v-chip>
                <v-chip v-else>
                  Nro. {{item.id}} -
                  {{item.tramite_solicitante_nombres}}
                  {{item.tramite_solicitante_primer_apellido}}
                  {{item.tramite_solicitante_segundo_apellido}} -
                  {{item.documento_nombre}}
                </v-chip>
              </template>
              <div v-if="!$store.state.selected || $store.state.selected === 0">
                <template>
                  No ha seleccionado documentos
                </template>
              </div>
            </div>

          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import crud from '@/common/util/crud-table/mixins/crud-table';
import Demofi from '@/common/util/DemofiGrupal';
import PdfView from '@/common/util/pdf/PdfView';
import Observar from './Observar.vue';
import DetalleDoc from './DetalleDoc';
import tramiteDoc from './mixins/tramite_doc';

const estados = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'info',
  OBSERVADO_ENTIDAD_REVISOR: 'warning',
  OBSERVADO_ENTIDAD_FIRMANTE: 'warning',
  FIRMADO_ENTIDAD: 'success',
  REVISADO_CANCILLERIA: 'info',
  OBSERVADO_CANCILLERIA_REVISOR: 'warning',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'warning',
  APOSTILLADO: 'primary'
};

const mensajes = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'El documento fue enviado correctamente para su posterior firma',
  OBSERVADO_ENTIDAD_REVISOR: 'El documento fue observado correctamente',
  OBSERVADO_ENTIDAD_FIRMANTE: 'El documento fue observado correctamente',
  FIRMADO_ENTIDAD: 'El documento fue firmado correctamente',
  REVISADO_CANCILLERIA: 'El documento fue enviado correctamente a cancillería para su verificación',
  OBSERVADO_CANCILLERIA_REVISOR: 'El documento fue observado correctamente',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'El documento fue observado correctamente',
  APOSTILLADO: 'El documento fue apostillado correctamente'
};

export default {
  props: {
    solicitud: {
      type: Object,
      default: () => {}
    }
  },
  mixins: [ tramiteDoc, crud ],
  data () {
    return {
      estados,
      tramite: {},
      pagos: [],
      pdf: null,
      urlPdf: null,
      detalles: true
    };
  },
  created () {
  },
  components: {
    Demofi,
    Observar,
    DetalleDoc,
    PdfView
  },
  methods: {
    firm (items) {
      let sinArchivos = [];
      for (let i in items) {
        if (parseInt(items[i].id_archivo) === 1) {
          sinArchivos.push(items[i].id);
        }
      }

      if (sinArchivos.length) {
        this.$message.warning(`Debe adjuntar un archivo PDF para los tramites: ${sinArchivos.join(' ')}`);
      } else {
        if (this.$store.state.user.id_rol === 4) {
          let errores = [];
          for (let i in items) {
            if (!items[i].pago_cancilleria) {
              errores.push(`Solicitud ${items[i].id}`);
            }
          } // validando pago en cancilleria

          if (errores.length) {
            this.$message.warning(`Debe realizar el pago correspondiente antes para poder firmar los siguientes documentos: <br> <strong>${errores.join('<br>')}</strong>`);
          } else {
            this.$confirm(items.length === 1 ? '¿Está seguro que desea aprobar este documento ?' : '¿Está seguro que desea aprobar estos documentos ?', () => {
              if (document.getElementById('btn-demofi-firm-grupal')) {
                document.getElementById('btn-demofi-firm-grupal').dispatchEvent(new window.Event('click'));
              } else {
                this.$message.warning('Tiene que iniciar su Token para poder firmar el documento');
              }
            });
          }
        } else {
          this.$confirm(items.length === 1 ? '¿Está seguro que desea aprobar este documento ?' : '¿Está seguro que desea aprobar estos documentos ?', () => {
            if (document.getElementById('btn-demofi-firm-grupal')) {
              document.getElementById('btn-demofi-firm-grupal').dispatchEvent(new window.Event('click'));
            } else {
              this.$message.warning('Tiene que iniciar su Token para poder firmar el documento');
            }
          });
        }
      }
    },
    cerrar_ventana () {
      this.$store.commit('closeModal', 7);
      document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
    },
    cambiarEstado (item) {
      if (item.mensajeError) {
        console.log('Error al firmar: ' + item.mensajeError);
        this.$message.error(item.mensajeError);
      } else {
        let estado = this.$store.state.user.id_rol === 4 ? 'APOSTILLADO' : 'FIRMADO_ENTIDAD';
        this.$message.success(mensajes[estado]);
      }
      this.$store.commit('closeModal', 7);
      document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
    }
  },
  watch: {
    '$store.state.archivo': function (val) {
      this.pdf = null;
      this.urlPdf = null;
      this.tramite.id_archivo = val;
      this.url = this.$apiUrl + 'eregister/upload/' + this.tramite.id + '/' + this.tramite.id_archivo;
      this.getPdf(val);
    },
    'solicitud.id': function (val) {
      console.log('Cambiando solicitud', val);
      if (val > 0) {
        // Cargando tramite
        this.$store.commit('setLoading', false);
        this.getTramite(val);
      }
    }
  }
};
</script>

<style src="./tramite.scss" lang="scss"></style>

<style lang="scss">
.demofi-container {
  padding: 0 20px 20px 0;
}
</style>



// WEBPACK FOOTER //
// FirmanteGrupal.vue?09e62512